<template>
  <div v-if="isStorageLevelIsCritial">
    <v-tooltip
      v-model="showToolTip"
      top
      color="red darken-4"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          outlined
          icon
          v-bind="attrs"
          v-on="on"
        >
        <v-icon>{{icons.mdiAlertOutline}}</v-icon>
        </v-btn>
      </template>
      <span>You are close to reaching your maximum storage limit(ie.
        {{ backendDataFilesUsedPercentage }}%).
        Please contact support to increase your storage limit.</span>
    </v-tooltip>
  </div>
</template>

<script>
import {
  mapActions,
} from 'vuex';
import {
  mdiAlertOutline,
} from '@mdi/js';

const CRITICAL_LEVEL = 95;
let hasCheckedThisSession = false;

const initdata = () => ({
  icons: {
    mdiAlertOutline,
  },
  showToolTip: true,
  backendDataFilesUsedPercentage: null,
});

export default {
  name: 'BackendFileStorageDetails',
  components: {},
  created() {
    if (!hasCheckedThisSession) {
      hasCheckedThisSession = true;
      this.getBackendStorageStats();
    }
  },
  data: () => initdata(),
  computed: {
    isStorageLevelIsCritial() {
      return this.backendDataFilesUsedPercentage > CRITICAL_LEVEL;
    },
  },
  methods: {
    ...mapActions('systemInfo', ['backendStorageStats']),
    async getBackendStorageStats() {
      const result = await this.backendStorageStats({
        criteria: {
          volumeType: 'backendDataFiles',
          isRequiredBackendDataFilesUsedPercentage: true,
        },
      });
      this.backendDataFilesUsedPercentage = (result || {}).backendDataFilesUsedPercentage || null;
    },
  },
};
</script>
